/* Copyright (c) 2021-2022, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum MicrophoneState {
    PermissionPending = 'PermissionPending',
    PermissionDenied = 'PermissionDenied',
    Muted = 'Muted',
    Unmuted = 'Unmuted',
    NoMicFound = 'NoMicFound'
}

export enum MicWarningToastMessage {
    PerformaceWarning = 'microphone.performanceWarning',
    PermissionBlocked = 'microphone.micBlockedWarning',
    PermissionBlockedMacOS = 'microphone.micBlockedWarningMacOS',
    PermissionBlockedWindows = 'microphone.micBlockedWarningWindows'
}

export const Undefined = 'undefined';

export const DefaultMicSettingChangeEventInfo = {
    startState: Undefined,
    requestedState: Undefined,
    streamSessionId: Undefined,
    subSessionId: Undefined,
    resultState: Undefined
};

export interface CustomMessage {
    messageType: string;
    messageRecipient?: string;
    data?: string;
}
